import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <p className="contact-description">
          Drop in at <strong>Rashtrothana Yogic Sciences and Research Institute</strong>, 
          Ajithsmruthi, Jayanagar 4th block (behind telephone exchange) during the following hours:
        </p>
        <ul className="contact-hours">
          <li>
            <strong>Evening:</strong> 4:30 PM - 7:30 PM (Mon, Wed, Fri)
          </li>
        </ul>
        <p className="contact-address">
          Address: Rashtrothana Yogic Sciences and Research Institute, Jayanagar, Bangalore
        </p>
        <h2>For any queries, Contact:</h2>
        <div className="contact-people">
          <p>
            <strong>Mrs. M.L. Tara:</strong> +91 98453 26168 <br />
            <strong>Mr. Renu Prasad:</strong> +91 94487 54034
          </p>
        </div>

        {/* Google Maps Embed */}
        <div className="map-container">
          <iframe
            title="Google Maps Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.7522028250432!2d77.58200287608015!3d12.923641687387349!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae159f8871eaaf%3A0x76ca7e658fc1bc77!2sRashtrotthana%20Fitness%20Center!5e0!3m2!1sen!2sin!4v1733379943855!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;